import "./ArchiveProductTemplate.module.css"
import Header from "@/reusable_sections/Header"
import ArchiveTitleSection from "./sections/ArchiveTitleSection"
import Listings from "./sections/Listings"

export default function ArchiveProductTemplatePage() {

  return (
    <div>
      <Header />
      <ArchiveTitleSection />
      <Listings />
    </div>
  )
}
